import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-contents-main',
	templateUrl:'./WaPageContentsMainProPage.html',
	styles: [],
	styleUrls:['./WaPageContentsMainProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageContentsMainProPage
{
	mdContent_390 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageContentsMain;
\`\`\``;
	mdContent_391 = `\`\`\`java
new WaPageContentsMain<>()
\`\`\``;
}
